import ModelTypeConstants from 'constants/ModelTypeConstants';
import {ClientId, NLOId, ToServerId} from 'notebook/ELNConstants';
import {MediocreSelection} from 'notebook/mediocre/EditorTypes';
import {CidIdMap} from 'notebook/notes/NoteConstants';
import {NoteEditor} from 'notebook/notes/NoteEditorTypes';
import getNotePartType from 'notebook/notes/util/getNotePartType';
import inspectAllNoteParts from 'notebook/notes/util/inspectAllNoteParts';
import {addCid} from 'notebook/store/StoreTransformUtil';
import {Note, NoteLinkedObjectType, NotePart} from 'notebook/util/NoteUtilConstants';
import {PlateRecord} from 'samples/plate-maps/plate-record/PlateRecordConstants';

export type GenericPlateRecord<TIds> = {
  name: string;
  type: NoteLinkedObjectType.NOTE_LINKED_PLATE_RECORD;
  plateRecord: PlateRecord;
} & NLOId<TIds>;

export type NoteLinkedPlateRecord = GenericPlateRecord<ClientId>;

export type ToServerNoteLinkedPlateRecord = Omit<GenericPlateRecord<ToServerId>, 'plateRecord'>;

export type PlateRecordNotePart = NotePart & {item: NoteLinkedPlateRecord};

const cidPrefix = 'plate-record';

export function getPlateRecordCid(cid: string): string {
  return `${cidPrefix}${cid}`;
}

export function fullSelection(this: NoteEditor, item: PlateRecordNotePart): MediocreSelection {
  return {
    selection: {
      cid: getPlateRecordCid(this.props.getCid(item)),
      start: 0,
      end: 0,
    },
  };
}

export function prepareForStore(item: NoteLinkedPlateRecord, cidIdMap: CidIdMap): void {
  addCid(item, cidPrefix, cidIdMap);
}

/**
 * Prepare a note linked plate record for save.
 *
 * We omit the plateRecord itself because plate records are immutable. The backend noops on plate record
 * patches anyway.
 */
export function prepareForSave(
  item: NoteLinkedPlateRecord,
  cidIdMap: CidIdMap
): ToServerNoteLinkedPlateRecord {
  return {
    id: cidIdMap[item.cid] as string,
    cid: item.cid,
    name: item.name,
    type: item.type,
  };
}

export function getAllPlateRecordNames(note: Note): Array<string> {
  const names: Array<string> = [];
  inspectAllNoteParts(note.noteParts, (notePart) => {
    if (getNotePartType(notePart) === ModelTypeConstants.NOTE_LINKED_PLATE_RECORD) {
      names.push((notePart.item as NoteLinkedPlateRecord).name);
    }
  });
  return names;
}
